import { render } from "./PasswordChangeFormContainer.vue?vue&type=template&id=3b78772c"
import script from "./PasswordChangeFormContainer.vue?vue&type=script&lang=js"
export * from "./PasswordChangeFormContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__